import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const timestamp = this.getData('timestamp')

        if (!timestamp) return 

        this.deadlineDate = new Date(timestamp * 1000);

        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings 
        Vue.config.devtools = true

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
    
            el: this.el,

            delimiters: ['${', '}'],
            
            data: () => {
                return {
                    countdownText: '000J:00H:00M:00S'
                }
            },

            created() {
                this.moduleInstance = moduleInstance
                this.startCountdown()
            },

            beforeDestroy() {
                this.endCountdown()
            },

            methods: {
                startCountdown() {
                    this.countdownInterval = setInterval(() => {
                        this.countdownText = this.computeDate()
                    }, 1000)
                },

                endCountdown() {
                    clearInterval(this.countdownInterval)
                    this.countdownInterval = null
                },

                computeDate() {
                    const {total, seconds, minutes, hours, days} = this.getTimeRemaining(moduleInstance.deadlineDate)

                    if (total <= 0) {
                        this.endCountdown()
                        return '000J:00H:00M:00S'
                    } else {
                        return `${this.uPad(days, 100)}J:${this.uPad(hours, 10)}H:${this.uPad(minutes, 10)}M:${this.uPad(seconds, 10)}S`
                    }
                },

                getTimeRemaining(endtime){
                    const total = Date.parse(endtime) - Date.parse(new Date());
                    const seconds = Math.floor( (total/1000) % 60 );
                    const minutes = Math.floor( (total/1000/60) % 60 );
                    const hours = Math.floor( (total/(1000*60*60)) % 24 );
                    const days = Math.floor( total/(1000*60*60*24) );
                    
                    return {
                        total,
                        days,
                        hours,
                        minutes,
                        seconds
                    };
                },

                /////////////////////////
                // Utils
                uPad(number, base) {
                    return number < base ? "0" + number.toString() : number.toString();
                },
            }
        })
    }

    destroy() {
        super.destroy()

        if (this.app) {
            this.app.$destroy();
        }
    }
}
 
